import React, { useEffect, useState } from 'react';
import styles from '../BasicCleanupsFilter/BasicCleanupsFilter.module.scss';
// import styles from './AdvancedCleanupsFilter.module.scss';
import AdvancedBasicCategories from './AdvancedBasicCategories/AdvancedBasicCategories';
import { CalciteButton, CalcitePanel, CalciteRadioButton } from '@esri/calcite-components-react';
import AdvancedInstitutionalControls from './AdvancedInstitutionalControls/AdvancedInstitutionalControls';
import AdvancedEngineeringControls from './AdvancedEngineeringControls/AdvancedEngineeringControls';
import AdvancedEnvironmentalIndicators from './AdvancedEnvironmentalIndicators/AdvancedEnvironmentalIndicators';
import ClearAllButton from '../../ClearAllButton/ClearAllButton';
import Extent from '@arcgis/core/geometry/Extent';
import { formatAdvancedCleanupFilters } from '../cleanupQuerySpecifications';

/* Legacy flat export labels retained temporarily for reference.
const normalizeSqlClause = (clause: string) =>
  clause.replace(/\s+/g, " ").trim().toUpperCase();

const advancedParamLabelMap: Record<string, string> = {
  [normalizeSqlClause("BF_ASSESS_IND = 'Y'")]: "Assessment Grants",
  [normalizeSqlClause("BF_ASSESS_PILOT_IND = 'Y'")]: "Assessment Pilots",
  [normalizeSqlClause("BF_CLEANUP_IND = 'Y'")]: "Cleanup Grants",
  [normalizeSqlClause("BF_RLF_GRANT_IND = 'Y'")]: "RLF Grants",
  [normalizeSqlClause("BF_RLF_PILOT_IND = 'Y'")]: "RLF Pilots",
  [normalizeSqlClause("BF_MULTIPURPOSE_IND = 'Y'")]: "Multi Purpose Grants",
  [normalizeSqlClause("BF_AWP_IND = 'Y'")]: "Area-Wide Planning Grants",
  [normalizeSqlClause("BF_128A_IND = 'Y'")]: "State and Tribal 128(a) Grants",
  [normalizeSqlClause("BF_128A_P_IND = 'Y'")]: "State and Tribal 128(a) Pilots",
  [normalizeSqlClause("BF_SHOWCASE_IND = 'Y'")]: "Showcase Community",
  [normalizeSqlClause("BF_READY_FOR_REUSE_IND = 'Y'")]: "Ready for Anticipated Use",

  [normalizeSqlClause("RCRA_CURRENT_IND='Y'")]: "Current Corrective Action",
  [normalizeSqlClause("RCRA_REMEDY_SEL_IND='Y'")]: "Remedy Selected",
  [normalizeSqlClause("RCRA_CONSTR_COMPLT_IND='Y'")]: "Construction Complete",
  [normalizeSqlClause("RCRA_REMEDY_COMPLT_IND='Y'")]: "Remedy Action Complete",
  [normalizeSqlClause("RCRA_REMEDY_NOT_SEL_IND='Y'")]: "Remedy Not Yet Selected",
  [normalizeSqlClause("RCRA_RAU_IND = 'Y'")]: "Ready for Anticipated Use",

  [normalizeSqlClause("SF_NPL_CODE_ALL = 'P' AND SF_NON_NPL_CODE = ''")]: "Proposed",
  [normalizeSqlClause("SF_NPL_CODE_ALL = 'F' AND SF_NON_NPL_CODE = ''")]: "Final",
  [normalizeSqlClause("SF_NPL_CODE_ALL = 'D' AND SF_NON_NPL_CODE = ''")]: "Deleted",
  [normalizeSqlClause("SF_ADMIN_FLAG='Y' AND SF_NON_NPL_CODE = ''")]: "Superfund Sites Targeted for Immediate, Intense Action",
  [normalizeSqlClause("SAA_SITE='Y' AND SF_NON_NPL_CODE = ''")]: "Superfund Alternative Approach (SAA) Agreement Sites",
  [normalizeSqlClause("SF_READY_FOR_REUSE_IND = 'Y' AND SF_NPL_CODE_ALL in ('P','A','F','D') AND SF_NON_NPL_CODE = ''")]: "Ready for Anticipated Use",

  [normalizeSqlClause("SF_NON_NPL_STATUS_SUBCATEG ='Additional Assessment Needed/Ongoing'")]: "Additional Assessment Needed/Ongoing",
  [normalizeSqlClause("SF_NON_NPL_STATUS_SUBCATEG ='Initial Assessment Needed/Ongoing'")]: "Initial Assessment Needed/Ongoing",
  [normalizeSqlClause("SF_NON_NPL_STATUS_SUBCATEG ='Status not specified'")]: "Status not specified",
  [normalizeSqlClause("SF_NON_NPL_STATUS_SUBCATEG ='Not Eligible for the NPL/No Further Remedial Action Planned'")]: "Not Eligible for the NPL",
  [normalizeSqlClause("SF_NON_NPL_STATUS_SUBCATEG ='Deferred to Nuclear Regulatory Commission'")]: "Deferred to Nuclear Regulatory Commission",
  [normalizeSqlClause("SF_NON_NPL_STATUS_SUBCATEG ='Deferred to RCRA Subtitle C Program'")]: "Deferred to RCRA Subtitle C Program",
  [normalizeSqlClause("SF_NON_NPL_STATUS_SUBCATEG ='Long-term Cleanup Attention Needed/Ongoing under EPA Enforcement Authority'")]: "Long-term Cleanup Attention Needed/Ongoing under EPA Enforcement Authority",
  [normalizeSqlClause("SF_NON_NPL_STATUS_SUBCATEG ='Long-term Cleanup Attention Needed/Ongoing under Local Government Program'")]: "Long-term Cleanup Attention Needed/Ongoing under Local Government Program",
  [normalizeSqlClause("SF_NON_NPL_STATUS_SUBCATEG ='Long-term Cleanup Attention Needed/Ongoing under Other Federal Agency'")]: "Long-term Cleanup Attention Needed/Ongoing under Other Federal Agency",
  [normalizeSqlClause("SF_NON_NPL_STATUS_SUBCATEG ='Long-term Cleanup Attention Needed/Ongoing under State Program'")]: "Long-term Cleanup Attention Needed/Ongoing under State Program",
  [normalizeSqlClause("SF_NON_NPL_STATUS_SUBCATEG ='Long-term Cleanup Attention Needed/Ongoing under Tribal Program'")]: "Long-term Cleanup Attention Needed/Ongoing under Tribal Program",
  [normalizeSqlClause("SF_NON_NPL_STATUS_SUBCATEG ='Submitted to or Addressed by Superfund Removal Program'")]: "Submitted to or Addressed by Superfund Removal Program",
  [normalizeSqlClause("SF_READY_FOR_REUSE_IND = 'Y' AND SF_NON_NPL_CODE <> ''")]: "Ready for Anticipated Use",

  [normalizeSqlClause("RCRA_EC_CODE='Y'")]: "Groundwater Controls",
  [normalizeSqlClause("RCRA_EC_CODE='N'")]: "Non Groundwater Controls",
  [normalizeSqlClause("RCRA_EC_CODE='U'")]: "No Control Information Reported",

  [normalizeSqlClause("RCRA_IC_CODE='Y'")]: "Controls are in place",
  [normalizeSqlClause("RCRA_IC_CODE='U'")]: "No controls in place or no control information reported",
  [normalizeSqlClause("RCRA_IC_PR_IND='Y'")]: "Proprietary",
  [normalizeSqlClause("RCRA_IC_GC_IND='Y'")]: "Governmental",
  [normalizeSqlClause("RCRA_IC_ID_IND='Y'")]: "Informational Devices",
  [normalizeSqlClause("RCRA_IC_EP_IND='Y'")]: "Enforcement/Permit Tools",
  [normalizeSqlClause("(RCRA_IC_CODE='U' and RCRA_IC_PR_IND='U' AND RCRA_IC_GC_IND='U' AND RCRA_IC_ID_IND='U' AND RCRA_IC_EP_IND='U')")]: "No types reported",

  [normalizeSqlClause("BF_IC_CODE='Y'")]: "Required",
  [normalizeSqlClause("BF_IC_CODE='N'")]: "Not Required",
  [normalizeSqlClause("BF_IC_CODE='U'")]: "No Control Information Reported",
  [normalizeSqlClause("BF_IC_PR_IND='Y'")]: "Proprietary",
  [normalizeSqlClause("BF_IC_GC_IND='Y'")]: "Governmental",
  [normalizeSqlClause("BF_IC_ID_IND='Y'")]: "Informational Devices",
  [normalizeSqlClause("BF_IC_EP_IND='Y'")]: "Enforcement/Permit Tools",
  [normalizeSqlClause("(BF_IC_CODE='U' AND BF_IC_PR_IND='U' AND BF_IC_GC_IND='U' AND BF_IC_ID_IND='U' AND BF_IC_EP_IND='U')")]: "No types reported",

  [normalizeSqlClause("SF_IC_IND='1' AND MAP_SYMBOL_CODE <> 'SN'")]: "Not required",
  [normalizeSqlClause("SF_IC_IND='2' AND MAP_SYMBOL_CODE <> 'SN'")]: "Required",
  [normalizeSqlClause("SF_IC_IND='3' AND MAP_SYMBOL_CODE <> 'SN'")]: "Required and Implemented",
  [normalizeSqlClause("SF_IC_IND='4' AND MAP_SYMBOL_CODE <> 'SN'")]: "No information is publicly available",

  [normalizeSqlClause("RCRA_EI_HE_CODE='Y'")]: "Human Exposures - Under Control",
  [normalizeSqlClause("RCRA_EI_HE_CODE='N'")]: "Human Exposures - Not Under Control",
  [normalizeSqlClause("RCRA_EI_HE_CODE='U'")]: "Human Exposures - No Control Information Reported",
  [normalizeSqlClause("RCRA_EI_GM_CODE='Y'")]: "Groundwater Migration - Under Control",
  [normalizeSqlClause("RCRA_EI_GM_CODE='N'")]: "Groundwater Migration - Not Under Control",
  [normalizeSqlClause("RCRA_EI_GM_CODE='U'")]: "Groundwater Migration - No Control Information Reported",

  [normalizeSqlClause("SF_EI_HE_CODE='Y' AND MAP_SYMBOL_CODE <> 'SN'")]: "NPL Human Exposures - Under Control",
  [normalizeSqlClause("SF_EI_HE_CODE='N' AND MAP_SYMBOL_CODE <> 'SN'")]: "NPL Human Exposures - Not Under Control",
  [normalizeSqlClause("SF_EI_HE_CODE='U' AND MAP_SYMBOL_CODE <> 'SN'")]: "NPL Human Exposures - No Control Information Reported",
  [normalizeSqlClause("SF_EI_GM_CODE='Y' AND MAP_SYMBOL_CODE <> 'SN'")]: "NPL Groundwater Migration - Under Control",
  [normalizeSqlClause("SF_EI_GM_CODE='N' AND MAP_SYMBOL_CODE <> 'SN'")]: "NPL Groundwater Migration - Not Under Control",
  [normalizeSqlClause("SF_EI_GM_CODE='U' AND MAP_SYMBOL_CODE <> 'SN'")]: "NPL Groundwater Migration - No Control Information Reported",

  [normalizeSqlClause("SF_EI_HE_CODE='Y' AND MAP_SYMBOL_CODE LIKE '%SN%'")]: "Non-NPL Human Exposures - Under Control",
  [normalizeSqlClause("SF_EI_HE_CODE='N' AND MAP_SYMBOL_CODE LIKE '%SN%")]: "Non-NPL Human Exposures - Not Under Control",
  [normalizeSqlClause("SF_EI_HE_CODE='U' AND MAP_SYMBOL_CODE LIKE '%SN%'")]: "Non-NPL Human Exposures - No Control Information Reported",
  [normalizeSqlClause("SF_EI_GM_CODE='Y' AND MAP_SYMBOL_CODE LIKE '%SN%'")]: "Non-NPL Groundwater Migration - Under Control",
  [normalizeSqlClause("SF_EI_GM_CODE='N' AND MAP_SYMBOL_CODE LIKE '%SN%'")]: "Non-NPL Groundwater Migration - Not Under Control",
  [normalizeSqlClause("SF_EI_GM_CODE='U' AND MAP_SYMBOL_CODE LIKE '%SN%'")]: "Non-NPL Groundwater Migration - No Control Information Reported"
};
*/

/*
Structure for the advanced cleanups filter component:
- this is the parent component α
- there are 4 subcomponents β(i) that contain the categories of advanced searching
- each subcomponent β(i) has their own subcomponents γ(j) that contain the checkbox divs for each subcategory (these are the leaf components)

  - the parent component α
    - recieves and passes sitesLayer down the component tree
    - hosts the matchesAny and signalClear hooks, which are passed down the entire component tree
      - matchesAny (true for ANY, false for ALL) indicates to the components whether one or all search parameter must be met
      - signalClear updates will re-render every component
    - contains updater functions that are passed down to each β component
      - each function updates the array storing the query parameters
    - updates the definition expression of the sites layer

  - the subcomponents β
    - recieve sitesLayer, matchesAny, and signalClear as props, and passes them down to the leaf components
    - hosts arrays in hooks that store data retrieved from leaf components
    - contains updater functions (similar to the parent component) that are passed down to leaf components, so that they can update the respective arrays
    - have their own functions to update the parent component with query parameters from their section
  
  - the leaf components γ
    - render the checkboxes
    - re-render when matchesAny or signalClear update
    - store query parameters that match the parameter value coupled with a checkbox
    - pass up object id values to the β component, which passes the query parameters within its scope up to the α component
    */

const AdvancedCleanupsFilter = (props) => {
  // matchesAny = true for matches ANY param, = false for matches ALL params, gets updated on radio button clicks
  let [matchesAny, setMatchesAny] = useState<boolean>(true);
  // signalClear value changes any time the clear button is clicked, re-rendering checkbox components
  const [signalClear, setSignalClear] = useState<number>(Math.random());
  // all of these 
  const [basicParams, setBasicParams] = useState<Array<string>>([]);
  const [institutionalParams, setInstitutionalParams] = useState<Array<string>>([]);
  const [engineeringParams, setEngineeringParams] = useState<Array<string>>([]);
  const [environmentalParams, setEnvironmentalParams] = useState<Array<string>>([]);

  // called by AdvancedBasicCategories.updateAllbasicParams()
  const updateBasicParams = (paramArray) => {
    // advancedBasicParams = paramArray;
    setBasicParams(paramArray);
  }

  // called by AdvancedInstitutionalControls.updateInstitutionalParams()
  const updateInstitutionalParams = (objectIds) => {
    setInstitutionalParams(objectIds);
  }

  // called by AdvancedEnvironmentalControls.updateEnvironmentalParams()
  const updateEnvironmentalParams = (objectIds) => {
    setEnvironmentalParams(objectIds);
  }

  // called by AdvancedEngineeringControls.updateEngineeringParams()
  const updateEngineeringParams = (objectIds) => {
    setEngineeringParams(objectIds);
  }

  const updateDefinitionExpression = () => {
    let defStr;
    let paramArray: Array<any> = [
      ...basicParams,
      ...engineeringParams,
      ...environmentalParams,
      ...institutionalParams
    ];
    if (paramArray.length > 0) {
      if (matchesAny === true) {
        defStr = paramArray.join(' OR ');
      } else if (matchesAny === false) {
        defStr = paramArray.join(' AND ');
      }
    } else {
      defStr = "1=0";
    }
    if (typeof props.updateAdvancedCleanupParamArray === "function") {
      props.updateAdvancedCleanupParamArray(paramArray);
    }
    if (typeof props.updateAdvancedCleanupMatchesAny === "function") {
      props.updateAdvancedCleanupMatchesAny(matchesAny);
    }
    if (typeof props.updateActiveCleanupFilterType === "function") {
      props.updateActiveCleanupFilterType('advanced');
    }
    if (typeof props.updateAdvancedCleanupFilterDescription === "function") {
      props.updateAdvancedCleanupFilterDescription(
        formatAdvancedCleanupFilters(paramArray, matchesAny)
      );
    }
    props.sitesLayerView.filter = {
      where: defStr
    }
    // props.sitesLayer.definitionExpression = defStr;
  }

  const reAlignMap = () => {
    if (props.sitesLayer.definitionExpression !== '1=0') {
      props.sitesLayer.queryExtent().then((response) => {
        if (response.extent.ymin > -19914421.299593817 && response.extent.ymax < 20056431.422842726) {
          props.view.goTo(response.extent).catch((error) => {
            console.error(error);
          });
        } else {
          let safeExtent = new Extent({
            "spatialReference": {
              "wkid": 102100
            },
            "xmin": 82084561.49065825,
            "ymin": -4424310.017654857,
            "xmax": 117150201.0905301,
            "ymax": 14830483.155489063,

          })
          props.view.goTo(safeExtent).catch((error) => { console.error(error); })
        }
      });
    }
  }
  const matchesAnyButton = matchesAny === true ? <CalciteRadioButton checked value="matchesAny" onCalciteRadioButtonChange={() => { setMatchesAny(!matchesAny) }} />
  : <CalciteRadioButton value="matchesAny" onCalciteRadioButtonChange={() => { setMatchesAny(!matchesAny) }} />;

  const matchesAllButton = matchesAny === false ? <CalciteRadioButton checked value="matchesAll" onCalciteRadioButtonChange={() => { setMatchesAny(!matchesAny) }} />
  : <CalciteRadioButton value="matchesAll" onCalciteRadioButtonChange={() => { setMatchesAny(!matchesAny) }} />;

  useEffect(() => { }, [signalClear, matchesAny, basicParams, institutionalParams, engineeringParams, environmentalParams])

  return (
    <>
      <div>
        <CalciteButton className={styles.FilterAndZoomButtons} onClick={() => { updateDefinitionExpression() }} iconStart={"layer-filter"}>Filter</CalciteButton>
        {/* <CalciteButton className={styles.FilterAndZoomButtons} onClick={() => { reAlignMap() }} iconStart={"zoom-to-object"}>Re-Align Map</CalciteButton> */}
        <ClearAllButton handleClick={() => {
          setSignalClear(Math.random());
          props.sitesLayerView.filter = { where: "1=0" };
          if (typeof props.updateAdvancedCleanupParamArray === "function") {
            props.updateAdvancedCleanupParamArray([]);
          }
          if (typeof props.updateAdvancedCleanupMatchesAny === "function") {
            props.updateAdvancedCleanupMatchesAny(matchesAny);
          }
          if (typeof props.updateActiveCleanupFilterType === "function") {
            props.updateActiveCleanupFilterType('advanced');
          }
          if (typeof props.updateAdvancedCleanupFilterDescription === "function") {
            props.updateAdvancedCleanupFilterDescription("no advanced filter applied");
          }
        }} />
        {/* <ClearAllButton handleClick={() => { setSignalClear(Math.random()); props.sitesLayer.definitionExpression = "1=0" }} /> */}
        <div className={styles.SectionTitleDivs}>
          {/* <CalciteRadioButton checked={matchesAny === true} value="matchesAny" onCalciteRadioButtonChange={() => { setMatchesAny(!matchesAny) }} /> */}
          {matchesAnyButton}
          <label className={styles.FilterSectionLabels}>Include cleanups that match ANY of the checked checkboxes below.</label>
        </div>
        <div className={styles.SectionTitleDivs}>
          {/* <CalciteRadioButton checked={matchesAny === false} value="matchesAll" onCalciteRadioButtonChange={() => { setMatchesAny(!matchesAny) }} /> */}
         {matchesAllButton}
          <label className={styles.FilterSectionLabels}>Include cleanups that match ALL of the checked checkboxes below.</label>
        </div>
      </div>

      <CalcitePanel className={styles.ParentPanel}>
        <label className={styles.SectionLabels} >Basic Categories</label>
        <AdvancedBasicCategories sitesLayer={props.sitesLayer} matchesAny={matchesAny}
          updateBasicParams={updateBasicParams} signalClear={signalClear} />
      </CalcitePanel>

      <CalcitePanel className={styles.ParentPanel}>
        <label className={styles.SectionLabels}>Institutional Controls</label>
        <AdvancedInstitutionalControls sitesLayer={props.sitesLayer} matchesAny={matchesAny}
          updateInstitutionalParams={updateInstitutionalParams} signalClear={signalClear} />
      </CalcitePanel>

      <CalcitePanel className={styles.ParentPanel}>
        <label className={styles.SectionLabels}>Engineering Controls</label>
        <AdvancedEngineeringControls sitesLayer={props.sitesLayer} matchesAny={matchesAny}
          updateEngineeringParams={updateEngineeringParams} signalClear={signalClear} />
      </CalcitePanel>

      <CalcitePanel className={styles.ParentPanel}>
        <label className={styles.SectionLabels}>Environmental Indicators</label>
        <AdvancedEnvironmentalIndicators sitesLayer={props.sitesLayer} matchesAny={matchesAny}
          updateEnvironmentalParams={updateEnvironmentalParams} signalClear={signalClear} />
      </CalcitePanel>
    </>
  );
}

export default AdvancedCleanupsFilter;